// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import DateRange from 'common/domain/DateRange';
import DateRangePickerInput from 'statsradio/components/ui/forms/DateRangePickerInput';
import CompareArrows from '@material-ui/icons/CompareArrows';
import { SecondaryButton } from 'statsradio/components/ui/forms/ButtonInput';

export const REFERENCE_DATE_ID = 'reference-date';
export const COMPARISON_DATE_ID = 'comparison-date';
export const COMPARE_BUTTON_ID = 'compare-button';

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  
  >:not(:last-child) {
    margin-right: ${props => props.theme.V3.metrics.margin.tiny}px; 
  }
`;

const ButtonLabel = styled.span`
  padding-left: 3px;
`;

const CancelComparison = styled.span`
  text-decoration: underline;
  color: ${props => props.theme.V3.colors.danger};
`;

interface Props {
  dateRange: DateRange;
  dateRangeCompared: ?DateRange;
  onDateRangeClick: (dateInputId: string) => void;
  onCompareClick: () => void;
  onCancelCompareClick: () => void;
  comparing: boolean;
  referenceDateOnFocus: boolean;
  comparisonDateOnFocus: boolean;

  t: any;
}

export function DateRangePopoverHeader(props: Props) {
  const {
    dateRange,
    dateRangeCompared,
    onDateRangeClick,
    onCompareClick,
    onCancelCompareClick,
    comparing,
    referenceDateOnFocus,
    comparisonDateOnFocus,
    t } = props;

  const onReferenceDateClick = () => {
    onDateRangeClick(REFERENCE_DATE_ID);
  };

  const onComparisonDateClick = () => {
    onDateRangeClick(COMPARISON_DATE_ID);
  };

  const comparedDateLabel =
    (<React.Fragment>
      {t('comparisonDate')}
      <CancelComparison onClick={onCancelCompareClick}>
        {t('cancelComparison')}
      </CancelComparison>
    </React.Fragment>);

  return (
    <Container>
      <DateRangePickerInput
        id={REFERENCE_DATE_ID}
        name={REFERENCE_DATE_ID}
        label={t('referenceDate')}
        dateRange={dateRange}
        focused={referenceDateOnFocus}
        onClick={onReferenceDateClick}
      />

      {!comparing &&
        <SecondaryButton
          id={COMPARE_BUTTON_ID}
          onClick={onCompareClick}
        >
          <CompareArrows />
          <ButtonLabel>{t('compare')}</ButtonLabel>
        </SecondaryButton>
      }

      {comparing &&
        <DateRangePickerInput
          id={COMPARISON_DATE_ID}
          name={COMPARISON_DATE_ID}
          label={comparedDateLabel}
          dateRange={dateRangeCompared}
          focused={comparisonDateOnFocus}
          onClick={onComparisonDateClick}
        />
      }
    </Container>
  );
}

export default translate('metrics')(DateRangePopoverHeader);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/DateRangePopoverHeader.js